const dsCart = (($) => {

    const cart_div = 'div#my-box',
        cart_products_div = 'div#cart-products',
        cart_product_div = 'div.product',
        box_total = 'div#box-total',
        quantity_div = 'p.cart-quantity',
        cart_redeem = 'button.box-cart-redeem',
        modal_cart = 'div.unavailable-modal',
        coupon_div = 'div.box-coupon',
        free = 150;

    function loadCart() {
        $(`${cart_div} ${cart_product_div} .remove-prod`).off('click').on('click', function () {
            removeFromCart(this);
        });
    }

    function addToCartProcess(availChecked = false, key = 0) {
        const el = doorstep.add_to_cart.el,
            product = doorstep.add_to_cart.product,
            quantity = doorstep.add_to_cart.quantity - doorstep.add_to_cart.in_cart,
            availability = getAvailability(availChecked, product);
        doorstep.add_to_cart.quantity = quantity;
        if (doorstep.mode === 'recurring' && !product.regular) {
            dsProduct.message(doorstep.add_to_cart.el, 'This product is not available for recurring orders.');
            doorstep.add_to_cart = {};
        } else {
            if (availability.success) {
                if (product.bundle) {
                    setBundle(product)
                        .then(addBundle)
                        .then(dsProduct.message(el, '<span class="success-msg">Bundle added to my box</span>'));
                } else if (doorstep.add_to_cart.quantity !== 0) {
                    addToCart().done(function () {
                        reloadBox('add', el, product, key);
                    });
                }
            } else {
                dsProduct.message(el, availability.message);
                doorstep.add_to_cart = {};
            }
        }
    }

    function setBundle(product) {
        const products = doorstep.add_to_cart.product.child_products,
            el = doorstep.add_to_cart.el,
            the_div = $(dsProduct.getViewDiv(dsUtilities.getView(el))).eq(dsProduct.getKey(el));
        let bundled_products = [];
        product.bundle_data.forEach(function (data, key) {
            const product = products.find((product) => product.id === data.id),
                index = products.findIndex((product) => product.id === data.id);
            if (product !== undefined) {
                product.bundle_quantity = data.q;
                product.bundle_el = $(the_div).find(!product.in_cart ? 'button.add-to-cart' : 'button.add').eq(index + 1);
                const availability = getAvailability(false, product)
                if (availability.success) {
                    bundled_products.push(product);
                }
            }
        });
        return new Promise(function (resolve, reject) {
            resolve(bundled_products)
        });
    }

    function addBundle(products) {
        Promise.all(products.map((product) => addToCart('bundle', product))).then(() => {
            loadCartBundle(products);
        });
    }

    function loadCartBundle(products) {
        const scrollPos = $('#my-box').scrollTop();
        $('#my-box-load').load(myBoxUrl(), function(response, status, xhr) {
            Promise.all(products.map((product) => finaliseBundle(product))).then(() => {
                loadCart();
                cartEvents();
                dsProduct.loadPage('products');
                doorstep.add_to_cart = {};
            });
        });
    }

    function finaliseBundle(product) {
        reloadBoxAdd('bundle', product.bundle_el, product, product.in_cart + product.bundle_quantity);
    }

    function reloadBox(action, el, product, key) {
        const scrollPos = $('#my-box').scrollTop();
        $('#my-box-load').load(myBoxUrl(), function(response, status, xhr) {
            loadCart();
            cartEvents();
            dsProduct.loadPage('products', product.id);
            if (action === 'add') {
                reloadBoxAdd(action, el, product, doorstep.add_to_cart.quantity + doorstep.add_to_cart.in_cart);
            }
            if (action === 'remove') {
                reloadBoxRemove(action, product, key);
            }
            if (action === 'clear') {
                reloadBoxClear(action);
            }
            $('#my-box').animate({
                scrollTop: scrollPos
            }, 0);
        });
    }

    function reloadEvents() {
        $('.tab').on('click', function() {
            myBoxToggle();
        });
    }

    function myBoxUrl() {
        return 'index.php?route=checkout/my_box&mybox=' + ($('div.my-box-show').length > 0 ? 1 : 0);
    }

    function reloadCart() {
        let url = new URL(location.href),
            params = new URLSearchParams(url.search);
        params.delete('mybox');
        params.delete('scroll');
        if ($(cart_div).hasClass('my-box-show')) {
            params.append('mybox', '1');
        }
        params.append('scroll', '1');
        url.search = params.toString();
        location.href = url.toString();
    }

    function getAvailability(availChecked, product) {
        if (product.bundle || availChecked || doorstep.mode === 'recurring') {
            return { success: true };
        } else {
            return dsAvailability.checkAvailability(product, doorstep.add_to_cart.quantity);
        }
    }

    function addToCart(action, product = {}) {
        const isBundle = action === 'bundle';
        return $.ajax({
            url: dsUtilities.urlCart() + '/add',
            type: 'post',
            data: {
                product_id : isBundle ? product.id : doorstep.add_to_cart.product.id,
                quantity   : isBundle ? product.bundle_quantity : doorstep.add_to_cart.quantity,
                price      : isBundle ? product.price : doorstep.add_to_cart.product.price
            },
            dataType: 'json'
        });
    }

    function reloadBoxAdd(action, el, product, quantity) {
        if (!isNaN(quantity)) {
            dsProduct.updateInCart(product.id, quantity);
            setSEO(product);
            if (product.mixed && doorstep.add_to_cart.in_cart === 0) {
                dsMixed.modalOpen(product.mixed);
            }
            if (dsUtilities.getView(el) !== 'order-info' && dsProduct.hasMessage(el) && action !== 'bundle') {
               dsProduct.message(el, `<span class="success-msg">Available for your delivery date.</span>`);
            }
            dsChannel.postMessage({ action: action, id: product.id, quantity: quantity }, doorstep.url);
        }
    }

    function reloadBoxRemove(action, product, key) {
        dsProduct.updateInCart(product.id, 0);
        dsProduct.resetButtons(product.id);
        dsChannel.postMessage({ action: action, id: product.id, key: key }, doorstep.url);
    }

    function reloadBoxClear(action) {
        doorstep.cart_products = [];
        doorstep.cart_count = 0;
        dsProduct.resetButtons();
        dsChannel.postMessage({ action: action }, doorstep.url);
    }

    function cartObjectIsValid() {
        return doorstep.add_to_cart.hasOwnProperty('el') &&
            doorstep.add_to_cart.hasOwnProperty('product') &&
            doorstep.add_to_cart.hasOwnProperty('quantity') &&
            doorstep.add_to_cart.hasOwnProperty('in_cart');
    }

    function removeFromCart(el) {
        const key = $(el).closest(cart_product_div).attr('data-key'),
            product = doorstep.cart_products[key],
            price_changed = priceChanged(product);
        if (canDelete(product)) {
            $.ajax({
                url: dsUtilities.urlCart() + '/remove_product',
                type: 'post',
                dataType: 'json',
                data: {
                    id            : product.id,
                    price_changed : price_changed,
                    quantity      : product.edit_in_cart,
                    price         : product.edit_product && product.price !== product.edit_price ? product.edit_price : product.price
                },
                success: function (response) {
                    if (response.success) {
                        reloadBox('remove', el, product, key);
                    }
                }
            });
        }
    }

    function canDelete(product) {
        if (!product.edit_product || ![4, 20].includes(doorstep.editstatus)) {
            return true
        }
        return false;
    }

    function clearCart() {
        $.ajax({
            url: dsUtilities.urlCart() + '/clear',
            type: 'post',
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    reloadBox('clear', '', '', '');
                }
            }
        });
    }

    function setSEO(product) {
        product.quantity = doorstep.add_to_cart.quantity;
        dsSEO.gtmAddToCart([product]);
    }

    function gotoCheckout() {
        let message = '';
        if (doorstep.cart_count > 0 && doorstep.checkout) {
            dsCoupon.couponCheck('', ['checkTotal','checkLessThanGreaterThan']).done(function(response) {
                if (response.error) {
                    message = response.message;
                }
                runCheck().done(function (response) {
                    if (response.error) {
                        message = response.message;
                    }
                    if (!message.length) {
                        if (doorstep.mode !== 'edit' || doorstep.address_id.toString().length === 0 || (isTempSensitive() && doorstep.edit_fresh < 4)) {
                            location.href = dsUtilities.urlCheckout();
                        } else {
                            location.href = dsUtilities.urlCheckout() + '&qe=1';
                        }
                    } else {
                        dsUtilities.cartModal(0, message);
                    }
                });
            });
        }
    }

    function runCheck() {
        return $.ajax({
            url      : dsUtilities.urlCart() + '/run_check',
            type     : 'post',
            dataType : 'json'
        });
    }

    function hasAlcohol() {
        if (doorstep.cart_products === undefined) {
            return doorstep.alcohol;
        }
        return doorstep.cart_products.filter(product => product.alcohol).length > 0;
    }

    function isTempSensitive() {
        if (doorstep.cart_products === undefined) {
            return false;
        }
        return doorstep.cart_products.filter(product => (product.fresh_code === 4 || product.fresh_code === 5)).length > 0;
    }

    function emptyCart() {
        return $.ajax({
            url: dsUtilities.urlCart() + '/empty',
            type: 'post',
            dataType: 'json'
        });
    }

    function setMode() {
        return $.ajax({
            url      : dsUtilities.urlCart() + '/set_mode',
            type     : 'post',
            dataType : 'json'
        });
    }

    function updateRecurringOrder() {
        let products = [];
        doorstep.cart_products.forEach(function (product) {
            products.push({
                'product_id' : product.id,
                'quantity'   : product.in_cart,
                'fractions'  : product.fractions,
                'brand'      : product.brand,
                'model'      : product.brand,
                'name'       : product.name,
                'size'       : product.size_free
            });
        });
        return $.ajax({
            url      : 'index.php?route=account/recurring_orders/add_products',
            type     : 'post',
            dataType : 'json',
            data     : { id : doorstep.recurring, products : products }
        });
    }

    function couponMessage(message, success = true) {
        $('div#coupon-message').removeClass('hide success-msg error-msg').addClass(success ? 'success-msg' : 'error-msg').html(message);
        dsChannel.postMessage({ action: 'reload' }, doorstep.url);
    }

    function couponRemove(code) {
        $(coupon_div + `[data-code="${code}"]`).remove();
    }

    function priceChanged(product) {
        let bool = false;
        if (doorstep.mode === 'edit') {
            doorstep.cart_products.forEach(function (p) {
                if (p.id === product.id && p.edit_price !== product.price) {
                    bool = true;
                }
            });
        }
        return bool;
    }

    function myBoxToggle() {
        const arrow = $('div.slider-box .next-arrow');
        $(cart_div).hasClass('my-box-show') ? $(arrow).show(): $(arrow).hide();
        $('div.my-box-hidden').toggleClass('my-box-show');
        $('div.tab-in').toggleClass('tab-out');
    }

    function writeCoupon(type, code) {
        $('div#coupon-message').addClass('hide').html('').after(`<div class="box-coupon success-msg coupon-not-empty" data-code="${code}">Active ${type}: ${code}</div>`);
        dsChannel.postMessage({ action: 'reload' }, doorstep.url);
    }

    function getCart() {
        return $.ajax({
            url: dsUtilities.urlCart() + '/get',
            type: 'get',
            dataType: 'json'
        });
    }

    function getProduct(id) {
        return $.ajax({
            url: dsUtilities.urlCart() + '/get_product',
            type: 'post',
            data: { id : id },
            dataType: 'json'
        });
    }

    function cartEvents() {
        $('a.clear-cart').on('click', function () {
            if (doorstep.mode ==='cart' && doorstep.cart_count > 0) {
                clearCart();
            }
            if (doorstep.mode === 'edit' && doorstep.editorder > 0) {
                location.href = dsUtilities.urlEdit() + `/canceledit&order_id=${doorstep.editorder}`;
            }
        });

        $(`${cart_div} button#cart-checkout`).on('click', function () {
            gotoCheckout();
        });

        $('.tab').on('click', function() {
            myBoxToggle();
        });

        $('button#cart_load_list').on('click', function () {
            location.href = 'index.php?route=account/shopping_lists';
        });

        $(cart_redeem).on('click', function () {
            dsCoupon.promoModalOpen();
        });

        $(cart_div).on('click', coupon_div, function () {
            dsCoupon.promoModalOpen($(this).attr('data-code'));
        });

        $('button#cart_save_list').on('click', function () {
            if (!doorstep.logged_in) {
                location.href = dsUtilities.urlLogin();
            } else {
                dsList.modalOpen(this, 'save');
            }
        });

        $(`${cart_div} button#recurring-finish`).on('click', function () {
            updateRecurringOrder().done(function (response) {
                if (response.success) {
                    location.href = response.url;
                }
            });
        });

        $(`${cart_div} button#recurring-cancel`).on('click', function () {
            emptyCart().done(function() {
                setMode().done(function (response) {
                    if (response.success) {
                        location.href = 'index.php?route=account/recurring_orders';
                    }
                });
            });
        });

        $(`${modal_cart} img.close-modal, ${modal_cart} .modal-close`).on('click', function () {
            if (doorstep.page_type === 'checkout') {
                dsCheckout.setQuickEdit(false);
            }
            const url = $(this).attr('data-url');
            if (url !== undefined && url.length > 0) {
                location.href = url;
            } else {
                $(modal_cart).addClass('hide');
            }
        });

        $('p#my-box-run-date').on('click', function () {
            if (doorstep.weight) {
                dsRuns.openWeightDate(this);
            } else {
                dsRuns.openModal(true);
            }
        });
    }

    $(document).ready(function () {

        cartEvents();

    });

    return {
        loadCart           : loadCart,
        addToCartProcess   : addToCartProcess,
        cartObjectIsValid  : cartObjectIsValid,
        emptyCart          : emptyCart,
        setMode            : setMode,
        couponMessage      : couponMessage,
        couponRemove       : couponRemove,
        priceChanged       : priceChanged,
        myBoxToggle        : myBoxToggle,
        gotoCheckout       : gotoCheckout,
        runCheck           : runCheck,
        hasAlcohol         : hasAlcohol,
        writeCoupon        : writeCoupon,
        getCart            : getCart,
        reloadCart         : reloadCart,
        cartEvents         : cartEvents,
        myBoxUrl           : myBoxUrl
    }
})(jQuery);